import { render, staticRenderFns } from "./new_review_form.vue?vue&type=template&id=3de52069&"
import script from "./new_review_form.vue?vue&type=script&lang=js&"
export * from "./new_review_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports